module.exports = __webpack_public_path__ + "img/seat.14efa825.svg";